import { isEmptyObject } from "../../utilities/objectHelper";
import {
  ChartConfiguration,
  FieldConfiguration,
  FieldConfigurationType,
  PivotConfiguration,
  ReportConfiguration,
  ReportType,
  TabularConfiguration,
  TileConfiguration,
} from "../api/biClient.types";
import { chartRelatedReportTypes } from "./chartRelatedReport.types";
import { isPivotReportType, isTabularReportType, isTileReportType } from "./reportTypeHelper";

export const getMeasureNames = (reportType: ReportType | undefined, configuration: ReportConfiguration | undefined) => {
  if (configuration === undefined || reportType === undefined) {
    return [];
  }
  if (isPivotReportType(reportType)) {
    const { values } = configuration as PivotConfiguration;
    return getPivotMeasureNames(values);
  }
  if (isTabularReportType(reportType)) {
    const { fields } = configuration as TabularConfiguration;
    return getTabularMeasureNames(fields);
  }
  if (chartRelatedReportTypes.includes(reportType)) {
    const { values } = configuration as ChartConfiguration;
    return getChartMeasureNames(values);
  }
  if (isTileReportType(reportType)) {
    const { fields } = configuration as TileConfiguration;
    return getTileMeasureNames(fields);
  }
  throw new Error("Report type not supported");
};

export const getTileMeasureNames = (fields: FieldConfiguration[]) => {
  return getTabularMeasureNames(fields);
};

export const getPivotMeasureNames = (values: FieldConfiguration[]) => {
  if (isEmptyObject(values)) {
    return [];
  }
  return values.map((c) => c.name).sort();
};

export const getTabularMeasureNames = (fields: FieldConfiguration[]) => {
  if (isEmptyObject(fields)) {
    return [];
  }
  return fields
    .filter((f) => f.type === FieldConfigurationType.Measure)
    .map((f) => f.name)
    .filter((f): f is string => !!f)
    .sort();
};

export const getChartMeasureNames = (values: FieldConfiguration[]) => {
  if (isEmptyObject(values)) {
    return [];
  }
  return values.map((c) => c.name).sort();
};
